/* cc-gallery-dots — see snippets/cc-gallery-dots.liquid.
   One dot per visible media slide in the mobile gallery slider;
   active dot follows Dawn's slideChanged (fires on swipe AND when a
   variant change scrolls the slider via setActiveMedia), tap scrolls
   the slider to that slide. No MutationObserver, no polling — the
   gallery DOM is stable (cc-gallery-variant-sync's lean updateMedia
   override never innerHTML-swaps it). Init guard per CONVENTIONS
   (duplicate section-loaded scripts execute twice). */

(() => {
  if (window.ccInitGuardGalleryDots) return;
  window.ccInitGuardGalleryDots = true;

  const init = () => {
    const viewer = document.querySelector("media-gallery slider-component[id^='GalleryViewer']");
    if (!viewer || viewer.querySelector('.cc-gallery-dots')) return;
    const list = viewer.querySelector("ul[id^='Slider-Gallery']");
    if (!list) return;
    const slides = Array.from(list.querySelectorAll('.product__media-item'));
    if (slides.length < 2) return;

    const nav = document.createElement('div');
    nav.className = 'cc-gallery-dots';

    const dots = slides.map((slide, i) => {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'cc-gallery-dots__dot';
      dot.setAttribute('aria-label', 'Go to image ' + (i + 1) + ' of ' + slides.length);
      dot.addEventListener('click', () => {
        list.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
      });
      nav.appendChild(dot);
      return dot;
    });

    viewer.appendChild(nav);

    const setActive = (slide) => {
      const i = slides.indexOf(slide);
      if (i < 0) return;
      dots.forEach((dot, j) => {
        dot.classList.toggle('cc-gallery-dots__dot--active', j === i);
        if (j === i) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    };

    setActive(list.querySelector('.product__media-item.is-active') || slides[0]);

    viewer.addEventListener('slideChanged', (e) => {
      if (e.detail && e.detail.currentElement) setActive(e.detail.currentElement);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
